var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({class:[
    _vm.mainClass,
    _vm.$attrs.class,
  ],style:([
    _vm.$attrs.style,
  ]),attrs:{"value":_vm.value,"color":_vm.defaultColor,"persistent-placeholder":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }